export default "__VITE_ASSET__23222aeb__"